export function getCookie(key) {
  let cookies = {};
  document.cookie.split(";").forEach(function(el) {
    let [k, v] = el.split("=");
    cookies[k.trim()] = v;
  });
  return cookies[key];
}
